import classNames from "classnames"
import s from '../../index.module.css';
import classes from './index.module.css';
import { Tabs } from "./components/Tabs";
import { Range } from "./components/Range";
import Button from "@UI/New/Button";
import { useDispatch, useSelector } from "react-redux";
import { useAddAlert } from "@/hooks/useAddAlert";
import { closeAllModal } from "@store/modalsSlise";
import { useCheckField } from "@pages/Main/Timetable/components/TimetableAnalytics/hooks/useCheckField";

const IntersectionCheck = ({data}) => {
    const isFormValid = useCheckField();
    const addAlert = useAddAlert();
    const dispatch = useDispatch();

    const check = () => {
        if(!isFormValid) {
            addAlert({type:'error', title: 'Ошибка', text: 'Заполните все поля'})
            return;
        }
        data.getData();
        dispatch(closeAllModal())
    }

    return (
        <div className={classNames(s.modalContainer, classes.modalContainer)}>
            <div className={s.modalHeader}>
            <div className={s.modalTitleContainer}>
                <span className={s.modalHeaderBigTitle}>
                    Проверить пересечение
                </span>
            </div>
            </div>
            <div className={classNames(s.contentWrapper, classes.contentWrapper)}>
               <Tabs />
               <Range />
               <Button 
                    onClick={check}
                    className={classes.button}>
                    Проверить пересечения
               </Button>
            </div>
        </div>
    )
}
export default IntersectionCheck;